import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63f9996d")

_pushScopeId("data-v-63f9996d")
const _hoisted_1 = { class: "flex-hack" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      type: "button",
      role: "button",
      "aria-label": _ctx.playBtnAriaLabel,
      class: "pw-player-button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args))),
      innerHTML: _ctx.playbtnString.value
    }, null, 8, ["aria-label", "innerHTML"]),
    (!_ctx.IS_IOS)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          type: "button",
          class: "pw-player-button",
          onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showVolume && _ctx.showVolume(...args))),
          onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.offVolumeHover && _ctx.offVolumeHover(...args))),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isMuted = !_ctx.isMuted)),
          innerHTML: _ctx.volumeBtnSvg,
          "aria-label": _ctx.muteBtnAriaLabel
        }, null, 40, ["innerHTML", "aria-label"]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: "volumeScroller hide",
      ref: "volumeBar",
      onMouseenter: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showVolume && _ctx.showVolume(...args))),
      onMouseleave: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.offVolumeHover && _ctx.offVolumeHover(...args)))
    }, [
      _createVNode("input", {
        type: "range",
        ref: "volumeSeeker",
        min: "0",
        max: "1",
        step: "0.01",
        style: _ctx.volumecss
      }, null, 4)
    ], 544)
  ]))
})